import api from './client.js'

export const seatsAPI = {
  getActive: () => api.get('/seats/active'),
  getLayouts: () => api.get('/seats/layouts'),
  createLayout: (name) => api.post('/seats/layouts', { name }),
  updateLayout: (id, name) => api.put(`/seats/layouts/${id}`, { name }),
  deleteLayout: (id) => api.delete(`/seats/layouts/${id}`),
  activateLayout: (id) => api.post(`/seats/layouts/${id}/activate`),
  deactivateAll: () => api.post('/seats/deactivate-all'),
  duplicateLayout: (id) => api.post(`/seats/layouts/${id}/duplicate`),
  addTable: (layoutId, label, seat_count) => api.post(`/seats/layouts/${layoutId}/tables`, { label, seat_count }),
  updateTable: (tableId, label, seat_count) => api.put(`/seats/tables/${tableId}`, { label, seat_count }),
  deleteTable: (tableId) => api.delete(`/seats/tables/${tableId}`),
  reorderTables: (layoutId, order) => api.put(`/seats/layouts/${layoutId}/reorder`, { order }),
  claimSeat: (table_id, seat_number) => api.post('/seats/claim', { table_id, seat_number }),
  releaseSeat: () => api.delete('/seats/claim'),
  removeClaim: (userId) => api.delete(`/seats/claims/${userId}`),
  resetAllClaims: (layoutId) => api.delete(`/seats/layouts/${layoutId}/claims`),
  adminReserve: (table_id, seat_number, reserved_name, user_id) => api.post('/seats/reserve', { table_id, seat_number, reserved_name, user_id }),
  searchUsers: (q) => api.get('/seats/search-users', { params: { q } }),
  updateLayoutConfig: (id, config) => api.put(`/seats/layouts/${id}/config`, { config }),
  removeClaimById: (claimId) => api.delete(`/seats/claim-by-id/${claimId}`),
  toggleCrown: (claimId) => api.post(`/seats/claims/${claimId}/crown`),
}
